import { useQuery } from 'react-query'
import { makeCoreGetRequest } from 'utils/api'
import { toStoresOptions } from './serializers'
import { handleQueryError } from 'utils/helpers'

export const getShopReceptionShops = (showNotification: Function, isEnabled: boolean) => {
  return useQuery(
    ['shop-codes'],
    async () => {
      const response = await makeCoreGetRequest('/shop-reception-mobile/home/user-shops')
      return toStoresOptions(response)
    },
    {
      onError: error =>
        handleQueryError(
          error,
          'A apărut o eroare la obtinerea listei de magazine.',
          showNotification
        ),
      enabled: isEnabled,
      retry: false
    }
  )
}

export const getShopReceptionHub = (showNotification: Function, isEnabled: boolean) => {
  return useQuery(
    ['app-hub-name'],
    async () => {
      const response = await makeCoreGetRequest('/shop-reception-mobile/home/hub-name')
      return response?.value
    },
    {
      onError: error =>
        handleQueryError(
          error,
          'A apărut o eroare la obtinerea informatiilor despre hub.',
          showNotification
        ),
      enabled: isEnabled,
      retry: false
    }
  )
}

export const getShopReceptionWarehouse = (showNotification: Function, isEnabled: boolean) => {
  return useQuery(
    ['app-deposit-name'],
    async () => {
      const response = await makeCoreGetRequest('/shop-reception-mobile/home/deposit-name')
      return response?.value
    },
    {
      onError: error =>
        handleQueryError(
          error,
          'A apărut o eroare la obtinerea informatiilor despre depozit.',
          showNotification
        ),
      enabled: isEnabled,
      retry: false
    }
  )
}

export const getWMSNoDailyReportsMessage = (showNotification: Function, isEnabled: boolean) => {
  return useQuery(
    ['wms-no-daily-reports-message'],
    async () => {
      const response = await makeCoreGetRequest(
        '/waste-management-system/meti-reports/notifications/missing-daily-reports'
      )
      return response
    },
    {
      onError: error =>
        handleQueryError(
          error,
          'A apărut o eroare la obtinerea informatiilor despre rapoartele zilnice.',
          showNotification
        ),
      enabled: isEnabled,
      retry: false
    }
  )
}
